<template>
  <div>

    <a-list class="mt-5 mb-20 text-dark" size="small" :pagination="pagination" bordered :data-source="dataRequest"
      :loading="loadingList">
      <a-list-item slot="renderItem" slot-scope="item, index">
        <span v-if="textHead === 'Leave of Absence'">
          <a-list-item-meta>
            <div slot="description">
              <p :style="{
                fontSize: '12px',
                fontWeight: '700',
                color: '#454545',
              }" class="mt-0 mb-0 font-web">
                {{
                  item.remark !== null &&
                    item.remark !== "null" &&
                    item.remark !== ""
                    ? item.remark
                    : ""
                }}
              </p>
              <p :style="{
                fontSize: '12px',
                fontWeight: '700',
                color: '#454545',
              }" class="mt-5 mb-0 font-web">

                <span style="font-weight:900;" class="font-web text-dark"
                  v-html="`${item.detail.toString().replace('_:::_', '&nbsp;&nbsp;&nbsp;').replace('::', '&nbsp;')}`"></span>
              </p>
            </div>
            <div slot="title">
              <h6 class="font-web font-weight-bold mt-5 mb-5">
                <a-tag :style="{ fontSize: '14px', fontWeight: '900' }">{{
                  item.absence_type === "long_term_medical"
                    ? "ลาระยะยาว"
                    : item.absence_type
                }}
                  {{ item.absence_amount }} Days.</a-tag>
              </h6>
              <p :style="{ fontSize: '12px' }" class="font-web mt-10 mb-0">
                <strong>Start : </strong>
                {{ moment(item.start_date).format("DD / MMM / YYYY") }}
              </p>
              <p :style="{ fontSize: '12px' }" class="font-web mt-0 mb-5">
                <strong>End : </strong>{{ moment(item.end_date).format("DD / MMM / YYYY") }}
              </p>
            </div>
            <a-avatar class="mt-10" shape="square" slot="avatar" :style="{
              backgroundColor:
                item.status === 'wait'
                  ? '#E8AA42'
                  : item.status === 'approve'
                    ? '#87d068'
                    : '#f50',
              verticalAlign: 'middle',
            }">
              <span class="text-uppercase">{{
                item.status
              }}</span>
            </a-avatar>
          </a-list-item-meta>
        </span>
        <span v-if="textHead === 'Flexible'">
          <a-list-item-meta>
            <div slot="description">
              <p :style="{
                fontSize: '12px',
                fontWeight: '700',
                color: '#454545',
              }" class="mt-0 mb-0 font-web">
                {{
                  !["", null, "null"].includes(item.detail) ? item.detail : ""
                }}
              </p>
            </div>
            <div slot="title">
              <h6 class="font-web font-weight-bold mt-5 mb-5">
                <a-tag>{{
                  item.flex_type === "full-day"
                    ? "เต็มวัน Full Day"
                    : item.flex_type === "am-half-day"
                      ? "ครึ่งวันเช้า AM : Half Day"
                      : "ครึ่งวันบ่าย PM : Half Day"
                }}</a-tag>
              </h6>
              <p :style="{ fontSize: '14px' }" class="font-web mt-15 mb-0">
                <strong>Selected Date : </strong>
                {{ moment(item.selected_date).format("DD / MMM / YYYY") }}
              </p>
              <p :style="{ fontSize: '14px' }" class="font-web mt-0 mb-10">
                <strong>Exchange for working days : </strong>{{ moment(item.move_to_date).format("DD / MMM / YYYY") }}
              </p>
            </div>
            <a-avatar class="mt-10" shape="square" slot="avatar" :style="{
              backgroundColor:
                item.status === 'wait'
                  ? '#E8AA42'
                  : item.status === 'approve'
                    ? '#87d068'
                    : '#f50',
              verticalAlign: 'middle',
            }">
              <span class="text-uppercase">{{
                item.status
              }}</span>
            </a-avatar>
          </a-list-item-meta>
        </span>
        <span v-if="
          textHead === 'Training / Seminar / Conference / Educational Visit'
        ">
          <a-list-item-meta>
            <div slot="description">
              <p :style="{
                fontSize: '12px',
                fontWeight: '700',
                color: '#454545',
              }" class="mt-0 mb-0 font-web">
                {{
                  !["", null, "null"].includes(item.remark) ? item.remark : ""
                }}
              </p>
              <p :style="{
                fontSize: '12px',
                fontWeight: '700',
                color: '#454545',
              }" class="mt-0 mb-0 font-web">
                {{
                  !["", null, "null"].includes(item.detail) ? item.detail : ""
                }}
              </p>
            </div>
            <div slot="title">
              <h6 class="font-web font-weight-bold mt-10 mb-0">
                <a-tag :style="{ fontSize: '14px', fontWeight: '900' }">{{ item.seminar_type }}
                  {{ item.seminar_amount }} Days.</a-tag>
              </h6>
              <p :style="{ fontSize: '12px' }" class="font-web mt-10 mb-0">
                <strong>Start : </strong>
                {{ moment(item.start_date).format("DD / MMM / YYYY") }}
              </p>
              <p :style="{ fontSize: '12px' }" class="font-web mt-0 mb-5">
                <strong>End : </strong>{{ moment(item.end_date).format("DD / MMM / YYYY") }}
              </p>
            </div>
            <a-avatar class="mt-10" shape="square" slot="avatar" :style="{
              backgroundColor:
                item.status === 'wait'
                  ? '#E8AA42'
                  : item.status === 'approve'
                    ? '#87d068'
                    : '#f50',
              verticalAlign: 'middle',
            }">
              <span class="text-capitalize">{{ item.status }}</span>
            </a-avatar>
          </a-list-item-meta>
        </span>
        <span v-if="textHead === 'รายการคำขอบันทึกเวลาปฏิบัติงาน'">
          <a-list-item-meta>
            <div slot="description">
              <p :style="{
                fontSize: '12px',
                fontWeight: '700',
                color: '#454545',
              }" class="mt-0 mb-0 font-web">
                {{
                  !["", null, "null"].includes(item.reason) ? item.reason : ""
                }}
              </p>
            </div>
            <div slot="title">
              <p class="mt-0 mb-0">
                <span class="text-muted">Date :</span>
                {{
                  item.start_time !== null
                    ? moment(item.start_time).format("DD / MMMM / YYYY")
                    : moment(item.end_time).format("DD / MMMM / YYYY")
                }}
              </p>
              <p class="mt-0 mb-0">
                <span class="text-muted">start :</span>
                <span class="ml-5 text-success">{{
                  item.start_time !== null
                    ? moment(item.start_time).locale("th").format("LTS")
                    : "-"
                }}</span>
                <span class="ml-5 text-muted">end :</span>
                <span class="ml-5 text-danger">{{
                  item.end_time !== null
                    ? moment(item.end_time).locale("th").format("LTS")
                    : "-"
                }}</span>
              </p>
            </div>
            <a-avatar shape="square" slot="avatar" size="large" :style="{
              backgroundColor:
                item.status === 'wait'
                  ? '#E8AA42'
                  : item.status === 'approve'
                    ? '#87d068'
                    : '#f50',
              verticalAlign: 'middle',
            }">
              <span class="text-capitalize">{{ item.status }}</span>
            </a-avatar>
          </a-list-item-meta>
        </span>

        <span v-if="textHead === 'Work from Home'">
          <a-list-item-meta>
            <div slot="description">
              <span class="font-web" v-html="item.detail"></span>
            </div>
            <div slot="title">
              <p class="mt-0 mb-0 font-weight-bold">
                <span class="text-muted mr-5">Selected Date :</span>
                <strong class="text-dark"> {{ moment(item.selected_date).format("DD / MMMM / YYYY") }}</strong>
              </p>
            </div>
            <a-avatar class="mt-10" shape="square" slot="avatar" :style="{
              backgroundColor:
                item.status === 'wait'
                  ? '#E8AA42'
                  : item.status === 'approve'
                    ? '#87d068'
                    : '#f50',
              verticalAlign: 'middle',
            }">
              <span class="text-uppercase">{{
                item.status
              }}</span>
            </a-avatar>
          </a-list-item-meta>
        </span>

        <span v-if="textHead === 'Form for requesting permission to travel abroad for personnel'">
          <a-list-item-meta>
            <div slot="description">
              <p :style="{
                fontSize: '12px',
                fontWeight: '700',
                color: '#454545',
              }" class="mt-0 mb-0 font-web">
                [ รายละเอียด ]
              </p>
            </div>
            <div slot="title">
              <p class="mt-0 mb-0">
                <span class="text-muted">เดินทาง : [ ประเทศ ]</span>
              </p>
              <p class="mt-0 mb-0">
                <span class="text-muted">ออกจากประเทศไทย :</span>
                <span class="ml-5 text-success">{{ moment().locale("th").format("DD / MMMM / YYYY") }}</span>
                <br>
                <span class="text-muted">กลับเข้าประเทศไทย :</span>
                <span class="ml-5 text-danger">{{ moment().locale("th").format("DD / MMMM / YYYY") }}</span>
              </p>
            </div>
            <a-avatar shape="square" slot="avatar" size="large" :style="{
              backgroundColor:
                item.status === 'wait'
                  ? '#E8AA42'
                  : item.status === 'approve'
                    ? '#87d068'
                    : '#f50',
              verticalAlign: 'middle',
            }">
              <span class="text-capitalize">{{ item.status }}</span>
            </a-avatar>
          </a-list-item-meta>
        </span>
      </a-list-item>
      <div slot="header">
        <p :style="{
          fontSize:
            ['Form for requesting permission to travel abroad for personnel', 'Training / Seminar / Conference / Educational Visit'].includes(`${textHead}`)
              ? '14px'
              : '16px',
          fontWeight: 700,
        }" class="mt-0 mb-0 font-weight-bold font-web">
          {{ textHead }}
        </p>
        <small class="mt-0 mb-0 font-web">{{ dataRequest.length }} requests</small>
      </div>
      <div slot="footer"> </div>
    </a-list>
  </div>
</template>

<script>
export default {
  props: {
    dataRequest: {
      type: Array,
      default: () => [],
    },
    textHead: {
      type: String,
      default: () => "",
    },
    loadingList: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      data: [],
      pagination: {
        onChange: (page) => {
        },
        pageSize: 5,
      },
    };
  },
};
</script>

<style>
.ant-list-header {
  background: #fafafa;
}
</style>